module.exports = __webpack_public_path__ + "static/remarketing-c110e5aab6ab845b9bdded6d8adc892d.jpg";